import MobileListCard from './MobileListCard';
import { dateWordShort } from '../../../helper/helper';

const CompanyMobileCard = ({ item, onOpen }) => (
  <MobileListCard
    title={item.name_commercial}
    onClick={() => onOpen(item._id)}
    metaItems={[{ label: 'Rejoint le', value: dateWordShort(new Date(item.createdAt)) }]}
    topRightBadge={
      item.bigAccounts?.length > 0 ? (
        <span className="inline-flex items-center rounded-md px-2 py-1 text-sm ring-1 ring-inset bg-gray-50 text-gray-600 ring-gray-500/10">
          {item.bigAccounts.join(', ')}
        </span>
      ) : null
    }
  />
);

export default CompanyMobileCard;
